<template>
    <!-- List Team Page -->
    <div class="page-layout blank contacts-manage">
        <div class="pb-10 pr-3 pl-3">
            <div class="d-flex flex-wrap justify-content-between align-items-center">
                <div class="breadcrumbnew mr-4">
                    <span>Contacts</span>
                    <a>Teams</a>
                </div>
                <div class="d-flex flex-wrap align-items-center" style="flex-grow: 1">
                    <div class="d-flex mr-4" style="flex-grow: 1">
                        <i class="icon icon-magnify icondefault" style="border-radius: 20px 0px 0px 20px; padding: 8px 16px; height: 37px;"></i>
                        <input class="w-100" type="text" v-model="search_key" @input="getMyTeams" placeholder="Search by Team Name, Group Email" style="border-radius: 0px 20px 20px 0px; padding-left: 10px;">
                    </div>
                    <div class="d-flex justify-content-center mr-4" style="background: #fff; border-radius: 20px; width: 10em">
                        <div class="d-flex justify-content-center align-items-center pointer" style="width: 50%; border-right: 0.5px solid #cce3fc" @click="teamsToShowStyle = 'grid'">
                            <img src="/static/images/images-new-theme/icons/grid.svg" width="18">
                        </div>
                        <div class="d-flex justify-content-center align-items-center pointer" style="width: 50%; border-left: 0.5px solid #cce3fc" @click="teamsToShowStyle = 'list'">
                            <img src="/static/images/images-new-theme/icons/list.svg" width="38">
                        </div>
                    </div>
                    <el-dropdown trigger="click" class="type-select mr-4">
                        <span class="el-dropdown-link d-flex justify-content-between w-100 px-3">
                            {{ teamsToShow }} <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/down-arrow-grey-full.svg" style="margin-right: 10px;">
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="teamsToShow = 'My Team'">My team</el-dropdown-item>
                            <el-dropdown-item @click.native="teamsToShow = 'Other Teams'">Other Teams</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <!-- <multiselect
                        class="diginew-multiselect-lightgrey diginew-rounded-corners mr-4 mt-2"
                        :options="['My Team','Other Teams']"
                        :close-on-select="true"
                        :show-labels="false"
                        v-model="teamsToShow"
                        @select="getTeams"
                        open-direction="bottom"
                        style="width: 12em !important;"
                    ></multiselect> -->
                    <button class="btn btn-new-green btn-wide px-6" @click="createTeam">+ Create New</button>
                </div>
            </div>
            <div style="background: #fff;padding-bottom: 10px;border-radius: 20px;">
                <div class="d-flex align-items-center justify-content-center h-100" v-if="ajaxCallInProgress">
                    <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
                </div>
                <div class="main-block" @scroll="infinteScroll" v-if="!ajaxCallInProgress && teamsToShowStyle == 'grid'" id="team-list-grid">
                    <div v-if="teamsToShow == 'My Team' && myTeams.length == 0 || teamsToShow == 'Other Teams' && otherTeams.length == 0" class="d-flex flex-column justify-content-center align-items-center text-center">
                        <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/happy-face.svg" width="200px" height="200px">
                        <span class="fs-18 fw-500">Create a Team</span>
                        <span class="fs-14">Share Call Reports, Helpdesk Tickets and other <br> DigiCollect applications with multiple users.</span>
                    </div>
                    <div class="d-flex align-items-center justify-content-center h-100" v-if="ajaxCallInProgress">
                        <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
                    </div>
                    <div v-if="teamsToShow == 'My Team' && myTeams.length > 0" class="d-flex flex-wrap justify-content-center py-8 px-14">
                        <div class="cards" v-for="(myTeam,index) in myTeams" :key="index" @click="$router.push('/editteam/' + myTeam._id)" style="height: 12em">
                            <div class="d-flex">
                                <div v-if="!myTeam.profile_pic" class="team-image mr-4">
                                    <span style="text-transform: uppercase;">{{ myTeam.name.split(" ")[0].charAt(0) }}{{ myTeam.name.split(" ").length > 1 ? myTeam.name.split(" ")[1].charAt(0) : "" }}</span>
                                </div>
                                <img v-else :src="myTeam.profile_pic" width="55px" height="55px" style="border-radius: 50%">
                                <div class="d-flex align-items-start flex-column justify-content-around ml-2">
                                    <span class="d-flex align-items-center">
                                        <img class="membersImage" v-if="myTeam.team_members[0]" :src="myTeam.team_members[0].profile_pic">
                                        <img class="membersImage" v-if="myTeam.team_members[1]" style="margin-left: -8px;" :src="myTeam.team_members[1].profile_pic">
                                        <img class="membersImage" v-if="myTeam.team_members[2]" style="margin-left: -8px;" :src="myTeam.team_members[2].profile_pic">
                                        <img class="membersImage" v-if="myTeam.team_members[3]" style="margin-left: -8px;" :src="myTeam.team_members[3].profile_pic">
                                        <img class="membersImage" v-if="myTeam.team_members[4]" style="margin-left: -8px;" :src="myTeam.team_members[4].profile_pic">
                                        <span v-if="myTeam.total_members > 5" class="fs-16 fw-600 ml-2">+{{ myTeam.total_members > 5 ? myTeam.total_members - 5 : '' }}</span>
                                    </span>
                                    <span class="fs-12" style="color: #001f35">{{ myTeam.total_members }} Members</span>
                                </div>
                            </div>
                            <div class="text-center d-flex flex-column mt-6">
                                <span class="fs-14 fw-600" style="overflow: hidden; text-overflow: ellipsis; height: 22px;">{{ myTeam.name }}</span>
                                <span class="fs-12" style="overflow: hidden; text-overflow: ellipsis;">{{ myTeam.email }}</span>
                            </div>
                        </div>
                    </div>
                    <div v-if="teamsToShow == 'Other Teams' && otherTeams.length > 0" class="d-flex flex-wrap py-8 px-14">
                        <div class="cards" v-for="(otherTeam,index) in otherTeams" :key="index" style="height: 15.5em">
                            <div class="d-flex">
                                <div v-if="!otherTeam.profile_pic" class="team-image mr-4">
                                    <span style="text-transform: uppercase;">{{ otherTeam.name.split(" ")[0].charAt(0) }}{{ otherTeam.name.split(" ").length > 1 ? otherTeam.name.split(" ")[1].charAt(0) : "" }}</span>
                                </div>
                                <img v-else :src="otherTeam.profile_pic" width="55px" height="55px" style="border-radius: 50%">
                                <div class="d-flex align-items-start flex-column justify-content-around ml-2">
                                    <span class="d-flex align-items-center">
                                        <img class="membersImage" v-if="otherTeam.team_members[0]" :src="otherTeam.team_members[0].profile_pic">
                                        <img class="membersImage" v-if="otherTeam.team_members[1]" style="margin-left: -8px;" :src="otherTeam.team_members[1].profile_pic">
                                        <img class="membersImage" v-if="otherTeam.team_members[2]" style="margin-left: -8px;" :src="otherTeam.team_members[2].profile_pic">
                                        <img class="membersImage" v-if="otherTeam.team_members[3]" style="margin-left: -8px;" :src="otherTeam.team_members[3].profile_pic">
                                        <img class="membersImage" v-if="otherTeam.team_members[4]" style="margin-left: -8px;" :src="otherTeam.team_members[4].profile_pic">
                                        <span v-if="otherTeam.total_members > 5" class="fs-16 fw-600 ml-2">+{{ otherTeam.total_members > 5 ? otherTeam.total_members - 5 : '' }}</span>
                                    </span>
                                    <span class="fs-12" style="color: #001f35">{{ otherTeam.total_members }} Members</span>
                                </div>
                            </div>
                            <div class="d-flex flex-column align-items-center mt-6">
                                <span class="fs-14 fw-600" style="overflow: hidden; text-overflow: ellipsis; height: 22px;">{{ otherTeam.name }}</span>
                                <span class="fs-12" style="overflow: hidden; text-overflow: ellipsis;">{{ otherTeam.email }}</span>
                                <button v-if="!otherTeam.request_sent" class="btn btn-des-small px-4 mt-4" style="background: #00448b; color: #fff; border: 1px solid #00448b; width: 10em" @click="sendRequest(otherTeam._id)">Send Request</button>
                                <button v-else class="btn btn-des-small ml-4 px-4 mt-4" style="background: transparent; color: #00448b; border: 1px solid #00448b; width: 10em" @click="cancelRequest(otherTeam._id)">Cancel Request</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex align-items-center justify-content-center h-100" v-if="call_in_progress_scroll">
                    <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
                </div>
            </div>
            <div class="table-block" v-if="!ajaxCallInProgress && teamsToShowStyle == 'list'">
                <table v-if="teamsToShow == 'My Team'" class="team-list-table w-100">
                    <thead>
                        <tr>
                            <th>
                                TEAM PICTURE
                            </th>
                            <th>
                                TEAM NAME
                            </th>
                            <th>
                                GROUP EMAIL
                            </th>
                            <th>
                                MEMBERS
                            </th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="ajaxCallInProgress && teamsToShow == 'My Team' && myTeams.length == 0">
                            <td colspan="5">
                                <div class="d-flex align-items-center justify-content-center h-100">
                                    <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
                                </div>
                            </td>
                        </tr>
                        <tr  v-if="!ajaxCallInProgress && teamsToShow == 'My Team' && myTeams.length == 0">
                            <td colspan="5">
                                <div class="d-flex align-items-center justify-content-center h-100">
                                    No My Team Found
                                </div>
                            </td>
                        </tr>
                        <tr class="pointer" v-for="(myTeam,index) in myTeams" :key="index" @click="$router.push('/editteam/' + myTeam._id)">
                            <td>
                                <div v-if="!myTeam.profile_pic" class="team-image-table mr-4">
                                    <span style="text-transform: uppercase;">{{ myTeam.name.split(" ")[0].charAt(0) }}{{ myTeam.name.split(" ").length > 1 ? myTeam.name.split(" ")[1].charAt(0) : "" }}</span>
                                </div>
                                <img v-else :src="myTeam.profile_pic" width="30px" height="30px" style="border-radius: 50%">
                            </td>
                            <td>
                                {{ myTeam.name }}
                            </td>
                            <td>
                                {{ myTeam.email }}
                            </td>
                            <td>
                                {{ myTeam.total_members }} Members
                            </td>
                            <td>
                                <span class="d-flex align-items-center">
                                    <img v-if="myTeam.team_members[0]" :src="myTeam.team_members[0].profile_pic" style="border-radius: 50%">
                                    <img v-if="myTeam.team_members[1]" :src="myTeam.team_members[1].profile_pic" style="border-radius: 50%">
                                    <img v-if="myTeam.team_members[2]" :src="myTeam.team_members[2].profile_pic" style="border-radius: 50%">
                                    <img v-if="myTeam.team_members[3]" :src="myTeam.team_members[3].profile_pic" style="border-radius: 50%">
                                    <img v-if="myTeam.team_members[4]" :src="myTeam.team_members[4].profile_pic" style="border-radius: 50%">
                                    <span v-if="myTeam.total_members > 5" class="fs-16 fw-600 ml-2">+{{ myTeam.total_members > 5 ? myTeam.total_members - 5 : '' }}</span>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <table v-if="teamsToShow == 'Other Teams'" class="team-list-table w-100">
                    <thead>
                        <tr>
                            <th>
                                TEAM PICTURE
                            </th>
                            <th>
                                TEAM NAME
                            </th>
                            <th>
                                GROUP EMAIL
                            </th>
                            <th>
                                MEMBERS
                            </th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr  v-if="ajaxCallInProgress && teamsToShow == 'Other Teams' && otherTeams.length == 0">
                            <td colspan="5">
                                <div class="d-flex align-items-center justify-content-center h-100">
                                    <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
                                </div>
                            </td>
                        </tr>
                        <tr  v-if="!ajaxCallInProgress && teamsToShow == 'Other Teams' && otherTeams.length == 0">
                            <td colspan="5">
                                <div class="d-flex align-items-center justify-content-center h-100">
                                    No Other Team Found
                                </div>
                            </td>
                        </tr>
                        <tr class="pointer" v-for="(otherTeam,index) in otherTeams" :key="index">
                            <td>
                                <div v-if="!otherTeam.profile_pic" class="team-image-table mr-4">
                                    <span style="text-transform: uppercase;">{{ otherTeam.name.split(" ")[0].charAt(0) }}{{ otherTeam.name.split(" ").length > 1 ? otherTeam.name.split(" ")[1].charAt(0) : "" }}</span>
                                </div>
                                <img v-else :src="otherTeam.profile_pic" width="30px" height="30px" style="border-radius: 50%">
                            </td>
                            <td>
                                {{ otherTeam.name }}
                            </td>
                            <td>
                                {{ otherTeam.email }}
                            </td>
                            <td>
                                {{ otherTeam.total_members }} Members
                            </td>
                            <td>
                                <span class="d-flex align-items-center">
                                    <img v-if="otherTeam.team_members[0]" :src="otherTeam.team_members[0].profile_pic" style="border-radius: 50%">
                                    <img v-if="otherTeam.team_members[1]" :src="otherTeam.team_members[1].profile_pic" style="border-radius: 50%">
                                    <img v-if="otherTeam.team_members[2]" :src="otherTeam.team_members[2].profile_pic" style="border-radius: 50%">
                                    <img v-if="otherTeam.team_members[3]" :src="otherTeam.team_members[3].profile_pic" style="border-radius: 50%">
                                    <img v-if="otherTeam.team_members[4]" :src="otherTeam.team_members[4].profile_pic" style="border-radius: 50%">
                                    <span v-if="otherTeam.total_members > 5" class="fs-16 fw-600 ml-2">+{{ otherTeam.total_members > 5 ? otherTeam.total_members - 5 : '' }}</span>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-if="!ajaxCallInProgress && teamsToShowStyle == 'list'" class="d-flex flex-wrap justify-content-end align-items-center bg-white py-2 px-4" style="border-bottom-left-radius: 5px; border-bottom-right-radius: 5px">
                <multiselect
                  class="diginew-multiselect-lightgrey no-default-icon down-arrow"
                  :options="pageLimit"
                  :close-on-select="true"
                  v-model.number="limit"
                  open-direction="top"
                  placeholder=""
                  style="width: 4.2em !important;"
                ></multiselect>
                <span class="page-info pr-2 pl-6 fw-500" style="height: 2.4rem;line-height: 2.4rem;color: #4e5764;font-size: 12px;">Per page</span>
                <button @click="firstPage()" :disabled="skip == 0" class="mt-1 pointer pagination-list">
                    <el-tooltip class="item" effect="dark" content="First Page" placement="top">
                        <i class="icon-chevron-double-left"></i>
                    </el-tooltip>
                </button>
                <button @click="previousPage()" :disabled="skip == 0" class="pagination-list mt-1 ml-2 pointer">
                    <el-tooltip class="item" effect="dark" content="Previous Page" placement="top">
                        <i class="icon icon-chevron-left"></i>
                    </el-tooltip>
                </button>
                <span class="px-2 fw-500 fs-14 mt-1">Showing {{getSkipCount}} - {{total>skip+limit?skip+limit:total}} of {{total}}</span>
                <button @click="nextPage()" :disabled="skip_temp >= total" class="pagination-list mt-1 mr-2 pointer">
                    <el-tooltip class="item" effect="dark" content="Next Page" placement="top">
                        <i class="icon icon-chevron-right"></i>
                    </el-tooltip>
                </button>
                <button @click="lastPage()" class="mt-1 pointer pagination-list" :disabled ="temp_total == total">
                    <el-tooltip class="item" effect="dark" content="Last Page" placement="top">
                        <i class="icon-chevron-double-right"></i>
                    </el-tooltip>
                </button>
            </div>
        </div>
        <create-team-modal modal_name="createTeamModal"></create-team-modal>
        <add-new-members-modal modal_name="addNewMembersModal" @newTeamName="newTeamName" :team_name="new_team_name"></add-new-members-modal>
        <request-sent modal_name="requestSent"></request-sent>
        <team-created modal_name="teamCreated" :team_name="new_team_name"></team-created>
    </div>
</template>

<script>
import CreateTeamModal from "./CreateTeamModal";
import AddNewMembersModal from "./AddNewMembersModal";
import RequestSent from "./alertModals/RequestSent";
import TeamCreated from "./alertModals/TeamCreated";
import { HalfCircleSpinner } from "epic-spinners";
import { EventBus } from './eventBus/nav-bar-event';
export default {
    data() {
        return {
            teamsToShow: "My Team",
            teamsToShowStyle: "grid",
            search_key: "",
            myTeams: [],
            otherTeams: [],
            skip:0,
            limit: 20,
            count: 0,
            total: 0,
            start: 0,
            skip_temp:0,
            temp_total:0,
            add_to_list: false,
            infinite_scroll_reached_end: false,
            new_team_name: "",
            ajaxCallInProgress: false,
            pageLimit: ['1','2','3','4','5','6','7','8','9','10','11','12','13','14','15'],
            call_in_progress_scroll: false
        }
    },
    components: {
        CreateTeamModal,
        AddNewMembersModal,
        RequestSent,
        TeamCreated,
        HalfCircleSpinner,
    },
    methods: {
        previousPage() {
            this.temp_total = 0
            this.skip_temp = 0
            if (this.skip == 0) {
                return;
            }
            this.skip = this.skip - this.limit <= 0 ? 0 : this.skip - this.limit;
            this.getTeams(this.teamsToShow);
        },
        nextPage() {
            this.skip_temp = this.skip + this.limit > this.total ? this.total : this.skip + this.limit;
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp;
            this.getTeams(this.teamsToShow);
        },
        firstPage(){
            this.temp_total = 0
            this.skip = 0
            this.limit = this.limit
            this.getTeams(this.teamsToShow);
        },
        lastPage() {
            this.skip_temp = 0
            this.skip = 0
            this.temp_total = this.total
            let no_of_pages = Math.ceil(this.total/this.limit)
            this.skip_temp = (no_of_pages * this.limit) - this.limit
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp
            this.getTeams(this.teamsToShow);
        },
        createTeam() {
            this.$modal.show("createTeamModal");
        },
        getTeams(type) {
            if (type == "My Team") {
                this.getMyTeams();
            } else if (type == "Other Teams") {
                this.getOtherTeams();
            }
        },
        // infinteScroll() {
        //     var scrollTop = document.getElementById('team-list-grid').scrollTop;
        //     var scrollHeight = document.getElementById('team-list-grid').scrollHeight;
        //     var offsetHeight = document.getElementById('team-list-grid').offsetHeight;
        //     var clientHeight = document.getElementById('team-list-grid').clientHeight;
        //     var contentHeight = scrollHeight - offsetHeight;
        //     if (contentHeight <= scrollTop)
        //     {
        //         if(!this.infinite_scroll_reached_end) {
        //             this.add_to_list = true;
        //             this.count++;
        //             this.getTeams(this.teamsToShow);
        //         }
        //     }
        // },
        infinteScroll(e){
            const {target} = e;
            if (Math.ceil(target.scrollTop) >=
                target.scrollHeight - target.offsetHeight) {
                //this code will run when the user scrolls to the bottom of this div so
                //you could do an api call here to implement lazy loading
                this.add_to_list = true;
                this.count++;
                this.getTeams(this.teamsToShow);
                this.bottom = true;

            }
        },
        newTeamName(name) {
            this.new_team_name = name;
        },
        async getMyTeams() {
            if (this.add_to_list) {
                this.call_in_progress_scroll = true;
            } else {
                this.ajaxCallInProgress = true;
            }
            let params = {
                limit: this.limit == "" || this.limit == 0 || this.limit < 0 ? 1 : this.limit,
                skip: this.skip,
                search_key: this.search_key,
            };
            let res = await this.$http.post("/teams/list", params);
            if (res.data.status_id == 1) {
                if (this.add_to_list) {
                    res.data.response.forEach(x => {
                        this.myTeams.push(x);
                    });
                } else {
                    this.myTeams = res.data.response;
                }
                if (res.data.response.length < 10) {
                    this.infinite_scroll_reached_end = true;
                }
                this.total = res.data.count;
                this.start = this.count * this.limit + 1;
                this.end = this.count * this.limit + this.limit < this.total ? this.count * this.limit + this.limit : this.total;
            }
            this.call_in_progress_scroll = false;
            this.ajaxCallInProgress = false;
        },
        async getOtherTeams() {
            if (this.add_to_list) {
                this.call_in_progress_scroll = true;
            } else {
                this.ajaxCallInProgress = true;
            }
            let params = {
                is_other: true,
                limit: this.limit == "" || this.limit == 0 || this.limit < 0 ? 1 : this.limit,
                skip: this.skip,
                search_key: this.search_key,
            };
            let res = await this.$http.post("/teams/list", params);
            if (res.data.status_id == 1) {
                if (this.add_to_list) {
                    res.data.response.forEach(x => {
                        this.otherTeams.push(x);
                    });
                } else {
                    this.otherTeams = res.data.response;
                }
                if (res.data.response.length < 10) {
                    this.infinite_scroll_reached_end = true;
                }
                this.total = res.data.count;
                this.start = this.count * this.limit + 1;
                this.end = this.count * this.limit + this.limit < this.total ? this.count * this.limit + this.limit : this.total;
            }
            this.call_in_progress_scroll = false;
            this.ajaxCallInProgress = false;
        },
        async sendRequest(id) {
            let res = await this.$http.post("/team_request/add", { team_id: id });
            if (res.data.status_id == 1) {
                this.$modal.show("requestSent");
                setTimeout(() => {
                    this.$modal.hide("requestSent");
                }, 1000);
                this.getTeams(this.teamsToShow);
            }
        },
        async cancelRequest(id) {
            let res = await this.$http.post("/team_request/cancel", { team_id: id });
            if (res.data.status_id == 1) {
                this.getTeams(this.teamsToShow);
            }
        }
    },
    mounted() {
        // let element = document.getElementById("team-list-grid");
        // if (element) {
        //     element.addEventListener("scroll", this.infinteScroll, false);
        // }
        if (localStorage.hasOwnProperty("create_team_direct")) {
            this.createTeam();
            localStorage.clear();
        }
    },
    // destroyed() {
    //     let element = document.getElementById("team-list-grid");
    //     if (element) {
    //         element.removeEventListener("scroll", this.infinteScroll, false);
    //     }
    // },
    created() {
        this.getTeams(this.teamsToShow);
    },
    computed:{

        getSkipCount(){
            if(this.total == 0) {
                return 0
            }else {
                let skip_count = this.skip>this.total?this.total:this.skip+1;
                return skip_count;
            }
        }
    },
    mounted() {
        EventBus.$on("teamCreateSuccess", ()=>{
            setTimeout(() => {
                this.getTeams(this.teamsToShow);
            }, 1000);
        })
    },
    watch: {
        count: function() {
            this.getTeams(this.teamsToShow);
        },
        search_key: function() {
            this.getTeams();
            this.getOtherTeams();
        },
        teamsToShow: function(){
            this.getTeams();
            this.getOtherTeams();
        },
        limit: function() {
            if (this.limit < 0) {
                this.limit = 0;
            }
            this.getTeams(this.teamsToShow);
        },
        teamsToShowStyle: function() {
            this.limit = 20;
            this.count = 0;
            this.total = 0;
            this.start = 0;
            this.add_to_list = false;
            this.infinite_scroll_reached_end = false;
            this.getTeams(this.teamsToShow);
        },
        teamsToShow: function() {
            this.add_to_list = false;
            this.infinite_scroll_reached_end = false;
            this.getTeams(this.teamsToShow);
        }
    }
}
</script>

<style scoped>
    .main-block {
        background: #fff;
        padding-bottom: 10px;
        border-radius: 20px;
        height: 44em;
        overflow-x: hidden;
        overflow-y: auto;
    }
    .cards {
        background: #e8efff;
        border-radius: 5px;
        padding: 20px;
        margin: 0px 0px 20px 20px;
        width: 18em;
        cursor: pointer;
    }
    .team-image {
        color: #fff;
        font-weight: 500;
        font-size: 25px;
        background: #091e42;
        border-radius: 50%;
        width: 56px;
        height: 56px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .team-image-table {
        color: #fff;
        font-weight: 500;
        font-size: 16px;
        background: #091e42;
        border-radius: 50%;
        width: 36px;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .team-list-table thead tr th {
        background: #005dae;
        color: #fff;
        padding: 10px 30px;
        font-size: 14px;
        font-weight: 600;
    }
    .team-list-table thead tr th:first-child {
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
    }
    .team-list-table thead tr th:last-child {
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
    }
    .team-list-table tbody tr td {
        background: #fff;
        padding: 13px 30px;
        font-size: 14px;
        font-weight: 500;
        border-bottom: 1px solid #f2f3f5;
    }
    .team-list-table tbody tr td span img {
        width: 30px !important;
        height: 30px !important;
        margin-left: -10px;
    }
    .membersImage {
        width: 20px !important;
        height: 20px !important;
        border-radius: 50%;
    }
    .forwardBackward {
        border-radius: 5px;
        background: #f4f4fb;
        padding: 4px;
    }
    .type-select {
        background: #fff;
        border-radius: 30px;
        height: 2.7em;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #000;
        width: 12em;
    }
</style>


// WEBPACK FOOTER //
// src/components/ListTeam.vue